import { roundToX } from "@lib/util"

function commercialPrice(price) {
  const roundedPrice = roundToX(price, 10, "up")
  const last2Decimal = parseInt(roundedPrice.toString().slice(-2))
  switch (last2Decimal) {
    case 0:
      return roundedPrice === 0 ? 0 : roundedPrice - 10
    case 10:
      return roundedPrice - 20
    case 20:
      return roundedPrice - 30
    default:
      return roundedPrice
  }
}

async function convertPrice(prices, coefA, coefB) {
  const cleanPrices = [],
    errorLines = []
  const pricesArray = prices.split("\n")

  if (isNaN(coefA) || isNaN(coefB) || coefA === "" || coefB === "" || coefA < 0 || coefB < 0) {
    return "Coefficients invalid"
  }

  for (let i = 0; i < pricesArray.length; i++) {
    // replace comma with dot, remove all non-numeric characters
    const cleanPrice = pricesArray[i]
      .trim()
      .replace(/[,]+/g, ".") // replace comma with dot
      .replace(/[^0-9-.]/g, "") // remove all non-numeric characters

    // skip error when pasting with a new line at the end
    if (i === pricesArray.length - 1 && cleanPrice === "") {
      continue
    }
    // check for error
    if (cleanPrice < 0 || cleanPrice === "" || (isNaN(cleanPrice) && cleanPrice !== "-")) {
      errorLines.push(i + 1)
    } else {
      // skip calculation if price is "-"
      if (cleanPrice === "-") {
        cleanPrices.push(cleanPrice)
        continue
      }
      // affine formula y = ax + b
      // eslint-disable-next-line
      const sum = coefA * cleanPrice + coefB
      cleanPrices.push(sum < 30 ? sum : commercialPrice(sum))
    }
  }

  // return error if any, else return the final prices
  if (errorLines.length > 0) {
    return `Error on line(s): ${errorLines.join(", ")}`
  } else {
    return cleanPrices.join("\n")
  }
}

export default convertPrice
